import style from './style.scss';

export const HighlightHighTemperature = props => (
	<span class={style.high_temperature}>{ props.children }</span>
);

export const HighlightLowTemperature = props => (
	<span class={style.low_temperature}>{ props.children }</span>
);

export const HighlightMeanTemperature = props => (
	<span class={style.mean_temperature}>{ props.children }</span>
);

export const HighlightRainfall = props => (
	<span class={style.rainfall}>{ props.children }</span>
);

export const HighlightWindGust = props => (
	<span class={style.high_wind_gust}>{ props.children }</span>
);



// WEBPACK FOOTER //
// ./components/highlight-values/index.js